"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeReferenceType = exports.MessageThreadType = exports.IndividualType = exports.ClassificationRoute = exports.MessageType = void 0;
var MessageType;
(function (MessageType) {
    MessageType["USER_MESSAGE"] = "USER_MESSAGE";
    MessageType["USER_MESSAGE_CANVAS_FOLLOW_UP"] = "USER_MESSAGE_CANVAS_FOLLOW_UP";
    MessageType["USER_MESSAGE_REPORTING_REQUEST"] = "USER_MESSAGE_REPORTING_REQUEST";
    MessageType["AI_MESSAGE"] = "AI_MESSAGE";
    MessageType["NEW_THREAD"] = "NEW_THREAD";
    MessageType["TOOL_CALL"] = "TOOL_CALL";
    MessageType["TOOL_RESULT"] = "TOOL_RESULT";
    MessageType["AI_MESSAGE_DOCUMENT"] = "AI_MESSAGE_DOCUMENT";
    MessageType["AI_MESSAGE_REPORTING"] = "AI_MESSAGE_REPORTING";
    MessageType["AI_MESSAGE_UI"] = "AI_MESSAGE_UI";
    MessageType["AI_STATUS_MESSAGE"] = "AI_STATUS_MESSAGE";
    MessageType["AI_CANVAS_MESSAGE"] = "AI_CANVAS_MESSAGE";
    MessageType["AI_TEST"] = "AI_TEST";
})(MessageType || (exports.MessageType = MessageType = {}));
var ClassificationRoute;
(function (ClassificationRoute) {
    ClassificationRoute["QA"] = "Q&A";
    ClassificationRoute["UI"] = "UI";
    ClassificationRoute["FORM_FILL"] = "FORM_FILL";
    ClassificationRoute["REPORTING"] = "REPORT";
    ClassificationRoute["ASSET_RETRIEVAL"] = "ASSET_RETRIEVAL";
    ClassificationRoute["GENERAL"] = "GENERAL";
})(ClassificationRoute || (exports.ClassificationRoute = ClassificationRoute = {}));
var IndividualType;
(function (IndividualType) {
    IndividualType["USER"] = "USER";
    IndividualType["EMPLOYEE"] = "EMPLOYEE";
})(IndividualType || (exports.IndividualType = IndividualType = {}));
var MessageThreadType;
(function (MessageThreadType) {
    MessageThreadType["PERSONA"] = "PERSONA";
    MessageThreadType["EMPLOYEE"] = "EMPLOYEE";
    MessageThreadType["NONE"] = "NONE";
})(MessageThreadType || (exports.MessageThreadType = MessageThreadType = {}));
var EmployeeReferenceType;
(function (EmployeeReferenceType) {
    EmployeeReferenceType["EMPLOYEE"] = "EMPLOYEE";
    EmployeeReferenceType["EMPLOYEE_RECORD"] = "EMPLOYEE_RECORD";
})(EmployeeReferenceType || (exports.EmployeeReferenceType = EmployeeReferenceType = {}));
